"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffsetParent = exports.InnerWrapper = exports.FadingOverlay = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colorUtils = require("../../utils/color-utils");
var _domUtils = require("../../utils/dom-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

var getColorStops = function getColorStops(color) {
  return "\n  ".concat((0, _colorUtils.transparentize)(color, 0), ",\n  ").concat(color, "\n");
};
var FadingOverlay = exports.FadingOverlay = _styledComponents["default"].div.attrs({
  className: 'has-reached-bottom has-reached-top should-animate'
}).withConfig({
  displayName: "styles__FadingOverlay",
  componentId: "sc-tjo4a0-0"
})(["height:100%;left:0;pointer-events:none;position:absolute;right:", "px;top:0;transform:translateZ(0);&::before,&::after{content:'';left:0;position:absolute;width:100%;}&::before{background:linear-gradient(to top,", ");height:20%;top:-1px;}&::after{background:linear-gradient(to bottom,", ");bottom:-1px;height:20%;}&.has-reached-top::before,&.has-reached-bottom::after{opacity:0;}&.should-animate::before,&.should-animate::after{transition:0.2s opacity ease-out;}"], function (p) {
  return p.isScrollable ? _domUtils.scrollbarWidth : 0;
}, function (p) {
  return getColorStops(p.color);
}, function (p) {
  return getColorStops(p.color);
});
var OffsetParent = exports.OffsetParent = _styledComponents["default"].div.withConfig({
  displayName: "styles__OffsetParent",
  componentId: "sc-tjo4a0-1"
})(["display:flex;flex-direction:column;position:relative;overflow:hidden;"]);
var InnerWrapper = exports.InnerWrapper = _styledComponents["default"].div.attrs({
  className: 'FadingOverlay__InnerWrapper'
}).withConfig({
  displayName: "styles__InnerWrapper",
  componentId: "sc-tjo4a0-2"
})(["max-height:100%;overflow:hidden;display:flex;flex-direction:column;flex:1;", ""], function (p) {
  return p.isScrollable && "\n    -webkit-overflow-scrolling: touch;\n    overflow-y: auto;\n  ";
});
//# sourceMappingURL=styles.js.map